import api from '@Services/api';
import { AxiosResponse } from 'axios';

export type StudentNotificationKind = 'attendance' | 'test_result';

/** One row of the student's unified WhatsApp/SMS message log. */
export type StudentNotificationRow = {
	kind: StudentNotificationKind;
	message_id: number;
	checkin_id: number | null;
	attempt_id: number | null;
	course_id: number;
	course_name: string;
	test_name: string | null;
	instructor_name: string;
	recipient: 'student' | 'parent';
	channel: 'sms' | 'whatsapp';
	status: string;
	error_code: string | null;
	last_error: string | null;
	phone_e164: string | null;
	template: string | null;
	params: string[] | null;
	/** Attendance rows only: the rendered message text the recipient read. */
	message_body: string | null;
	created_at: string;
	updated_at: string;
};

export type StudentNotificationsMeta = {
	total: number;
	per_page: number;
	current_page: number;
	last_page: number;
};

/**
 * Student → Notifications subtab: test-result AND center-attendance
 * messages in one log, with a per-row WhatsApp retry.
 */
export class StudentNotificationsRequester {
	private static instance: StudentNotificationsRequester;
	static getInstance() {
		if (!StudentNotificationsRequester.instance) {
			StudentNotificationsRequester.instance = new StudentNotificationsRequester();
		}
		return StudentNotificationsRequester.instance;
	}

	baseURL = 'user/profile';

	async list(payload: {
		student_id: number | string;
		page?: number;
		perPage?: number;
	}): Promise<
		AxiosResponse<
			ApiResponse<StudentNotificationRow[]> & { meta: StudentNotificationsMeta }
		>
	> {
		const { student_id, ...body } = payload;
		return await api.post(`${this.baseURL}/${student_id}/notifications`, body);
	}

	async resend(payload: {
		student_id: number | string;
		kind: StudentNotificationKind;
		checkin_id?: number | null;
		attempt_id?: number | null;
		recipient: 'student' | 'parent';
	}): Promise<AxiosResponse<ApiResponse<{ id: number; status: string }>>> {
		const { student_id, ...body } = payload;
		return await api.post(
			`${this.baseURL}/${student_id}/notifications/resend`,
			body
		);
	}
}
